
<mat-form-field>
    <mat-select class="_text-md" [formControl]="selectedCurrency" (selectionChange)="onSelectionChanged($event)">
        <mat-option *ngFor="let currency of currencies" [value]="currency">
            {{ currency }}
        </mat-option>
    </mat-select>
</mat-form-field>

